import createIcon from '../../createIcon';

/**
 * @component @name PublishedWithChanges
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNjYgOS41MzAwNUwxMC41OSAxNi42TDYuMzUgMTIuMzZMNy43NiAxMC45NUwxMC41OSAxMy43OEwxNi4yNSA4LjEyMDA1TDE3LjY2IDkuNTMwMDVaTTQgMTJDNCA5LjY3MDA1IDUuMDIgNy41ODAwNSA2LjYyIDYuMTIwMDVMOSA4LjUwMDA1VjIuNTAwMDVIM0w1LjIgNC43MDAwNUMzLjI0IDYuNTIwMDUgMiA5LjExMDA1IDIgMTJDMiAxNy4xOSA1Ljk1IDIxLjQ1MDEgMTEgMjEuOTUwMVYxOS45M0M3LjA2IDE5LjQ0MDEgNCAxNi4wNyA0IDEyWk0yMiAxMkMyMiA2LjgxMDA1IDE4LjA1IDIuNTUwMDUgMTMgMi4wNTAwNVY0LjA3MDA1QzE2Ljk0IDQuNTYwMDUgMjAgNy45MzAwNSAyMCAxMkMyMCAxNC4zMyAxOC45OCAxNi40MiAxNy4zOCAxNy44OEwxNSAxNS41VjIxLjVIMjFMMTguOCAxOS4zQzIwLjc2IDE3LjQ4IDIyIDE0Ljg5IDIyIDEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PublishedWithChanges = createIcon('PublishedWithChanges', [
  [
    'path',
    {
      d: 'M17.66 9.53005L10.59 16.6L6.35 12.36L7.76 10.95L10.59 13.78L16.25 8.12005L17.66 9.53005ZM4 12C4 9.67005 5.02 7.58005 6.62 6.12005L9 8.50005V2.50005H3L5.2 4.70005C3.24 6.52005 2 9.11005 2 12C2 17.19 5.95 21.4501 11 21.9501V19.93C7.06 19.4401 4 16.07 4 12ZM22 12C22 6.81005 18.05 2.55005 13 2.05005V4.07005C16.94 4.56005 20 7.93005 20 12C20 14.33 18.98 16.42 17.38 17.88L15 15.5V21.5H21L18.8 19.3C20.76 17.48 22 14.89 22 12Z',
      key: '14h3a4',
    },
  ],
]);

export default PublishedWithChanges;
